import { createTheme } from "@mui/material";
import { BLACK, GREEN, PRIMARY, RED, YELLOW } from "./colors";

const rootElement = document.getElementById("root");

const typography = {
  fontFamily: [
    "Roboto",
    "Nunito",
    "-apple-system",
    "BlinkMacSystemFont",
    "sans-serif",
  ].join(","),
  htmlFontSize: 14,
  fontSize: 14,
  lineHeight: "16px",
  "@media (max-width:640px)": {
    fontSize: 12,
  },
  h1: {
    fontSize: 96,
    lineHeight: "134px",
    fontWeight: "light",
    "@media (max-width:640px)": {
      fontSize: 72,
    },
  },
  h2: {
    fontSize: 60,
    lineHeight: "90px",
    fontWeight: "light",
    "@media (max-width:640px)": {
      fontSize: 50,
    },
  },
  h3: {
    fontSize: 30,
    lineHeight: "48px",
    fontWeight: 700,
    "@media (max-width:640px)": {
      fontSize: 28,
    },
  },
  h4: {
    fontSize: 26,
    lineHeight: "36px",
    fontWeight: 700,
    "@media (max-width:640px)": {
      fontSize: 24,
    },
  },
  h5: {
    fontSize: 24,
    lineHeight: "28px",
    fontWeight: 500,
    "@media (max-width:640px)": {
      fontSize: 22,
    },
  },
  h6: {
    fontSize: 19,
    lineHeight: "23px",
    fontWeight: 500,
    "@media (max-width:640px)": {
      fontSize: 17,
    },
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: "21px",
    fontWeight: 500,
    "@media (max-width:640px)": {
      fontSize: 14,
    },
  },
  subtitle2: {
    fontSize: 13,
    lineHeight: "16px",
    fontWeight: 500,
    "@media (max-width:640px)": {
      fontSize: 12,
    },
  },
  body1: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: "normal",
    "@media (max-width:640px)": {
      fontSize: 14,
    },
  },
  body2: {
    fontSize: 13,
    lineHeight: "16px",
    fontWeight: "normal",
    "@media (max-width:640px)": {
      fontSize: 12,
    },
  },
  menuBody: {
    fontSize: 14,
    lineHeight: "16px",
    fontWeight: "normal",
    "@media (max-width:640px)": {
      fontSize: 13,
    },
  },
  caption: { fontSize: 13, lineHeight: "15px", fontWeight: "normal" },
  tiny: { fontSize: 10, lineHeight: "12px", fontWeight: "normal" },
  button: {
    fontSize: 14,
    textTransform: "none",
    lineHeight: "16px",
    fontWeight: 400,
  },
};

export const themeConfig = createTheme({
  // breakpoints: {
  //   values: {
  //     mobile: 0,
  //     tablet: 640,
  //     laptop: 1024,
  //     desktop: 1200,
  //   },
  // },
  palette: {
    mode: "light",
    primary: {
      main: PRIMARY,
      dark: PRIMARY,
    },
    secondary: {
      main: BLACK,
      dark: BLACK,
    },
    success: {
      main: GREEN,
      dark: GREEN,
    },
    error: {
      main: RED,
      light: RED,
      dark: RED,
    },
    warning: {
      main: YELLOW,
      light: YELLOW,
      dark: YELLOW,
    },
  },
  typography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          ":hover": {
            opacity: 0.9,
          },
        },
        contained: {
          color: "white",
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 4,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "#FF3B30",
          "&$error": {
            color: "#FF3B30",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: RED,
        },
      },

      defaultProps: {
        sx: {
          ...typography.body2,
          // backgroundColor: WHITE,
          padding: "2px",
        },
        shrink: {
          ...typography.body2,
          // backgroundColor: WHITE,
          padding: "2px",
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: true,
        sx: {
          ...typography.body2,
          borderRadius: "8px",
          // borderColor: GRAY_SCALE,
        },
        shrink: {
          ...typography.body2,
          borderRadius: "8px",
          // borderColor: GRAY_SCALE,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        InputProps: {
          style: { height: 54 },
        },
      },
      styleOverrides: {
        sx: { ...typography.body2 },
        shrink: { ...typography.body2 },
      },
    },
    MuiPopover: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiPopper: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        action: {
          display: "flex",
          flex: 1,
          justifyContent: "flex-end",
          margin: 0,
        },
        content: {
          width: "fit-content",
          flex: "inherit",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        tag: {
          ...typography.body2,
          margin: "1px 3px",
        },
      },
    },

    MuiDialog: {
      defaultProps: {
        container: rootElement,
      },
    },
  },
});
